// Small pill toggle switch, e.g. "Show X (N)". Controlled: checked + onChange(bool).
export function Switch({ checked, onChange, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className="inline-flex items-center gap-2.5 rounded-lg px-1 py-1 text-left"
    >
      <span
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
          checked ? 'bg-brand' : 'bg-slate-300 dark:bg-white/15'
        }`}
      >
        <span
          className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform ${
            checked ? 'translate-x-[19px]' : 'translate-x-[3px]'
          }`}
        />
      </span>
      {label && <span className="text-xs font-medium text-slate-600 dark:text-slate-300">{label}</span>}
    </button>
  );
}
